var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSupplier = function SvgSupplier(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.462 150.462",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(434.138 287.342)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.231,
    cy: 75.231,
    r: 75.231,
    fill: "#adcce9",
    "data-name": "Ellipse 7",
    transform: "translate(-434.138 -287.342)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "lieferschein (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 38"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#135899",
    d: "M-330.848-240.903h-10.29v10.279a3.43 3.43 0 0 1-3.432 3.432h-27.418a3.43 3.43 0 0 1-3.432-3.432v-10.279h-10.286a3.43 3.43 0 0 0-3.432 3.432v61.7a3.43 3.43 0 0 0 3.432 3.432h54.85a3.43 3.43 0 0 0 3.432-3.432v-61.708a3.43 3.43 0 0 0-3.424-3.424m-38.716 53.835a3.438 3.438 0 1 1 1-2.424 3.44 3.44 0 0 1-1 2.424m0-13.711a3.437 3.437 0 1 1 1-2.424 3.44 3.44 0 0 1-1 2.424m0-13.711a3.437 3.437 0 1 1 1-2.424 3.44 3.44 0 0 1-1 2.424m25 28.429h-13.713a3.432 3.432 0 0 1 0-6.863h13.711a3.432 3.432 0 1 1 0 6.863Zm0-13.719h-13.713a3.432 3.432 0 0 1 0-6.863h13.711a3.432 3.432 0 1 1 0 6.863Zm0-13.711h-13.713a3.428 3.428 0 1 1 0-6.855h13.711a3.428 3.428 0 1 1 0 6.855Z",
    "data-name": "Pfad 67"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 41"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#135899",
    d: "M-351.422-240.911a3.43 3.43 0 0 1-3.431-3.431v-4.568a3.428 3.428 0 1 0-6.855 0v4.568a3.43 3.43 0 0 1-3.432 3.432h-3.432v6.855h20.566v-6.856Z",
    "data-name": "Pfad 68"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSupplier);
export default ForwardRef;